import { CurrencyFormat } from "../../../../components/helpers";

export const convertCapitalOutletList = (capitalOutlets) => {
  let convertedCapitalOutlets = [];

  if (!capitalOutlets) return [];

  capitalOutlets.forEach((capitalOutlet, index) => {
    const isMaxLessThanAvg =
      capitalOutlet.max < capitalOutlet.average_expenditure;

    convertedCapitalOutlets.push({
      key: index + 1,
      outletID: capitalOutlet.outlet_id,
      outletName: capitalOutlet.outlet_name || "-",
      averageSpending: `Rp ${
        CurrencyFormat(capitalOutlet.average_expenditure) || 0
      }`,
      maxAmount: (
        <span style={{ color: isMaxLessThanAvg && "red" }}>
          Rp {CurrencyFormat(capitalOutlet.max) || 0}
        </span>
      ),
      minAmount: `Rp ${CurrencyFormat(capitalOutlet.min) || 0}`,
    });
  });

  return convertedCapitalOutlets;
};
